import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

import Axios from '@/lib/axios-instance';

type APIPayload = {
  question?: string;
  answer?: string;
  is_active?: boolean;
};

type ResponseType = {
  data: any;
  meta: any;
};

type Props = {
  id: string;
  payload: APIPayload;
};

export const updateQuestion = async (payload: APIPayload, id: string) => {
  try {
    const response = await Axios.put(`/questions/${id}`, payload);
    return response.data;
  } catch (error: any) {
    if (error.response) {
      throw new Error(
        `${error.response.data?.meta?.message || 'An error occurred'}`,
      );
    }
    throw new Error(error.message || 'Network Error');
  }
};

export const useUpdateQuestion = () => {
  const queryClient = useQueryClient();
  return useMutation<ResponseType, Error, Props>({
    mutationFn: ({ id, payload }) => updateQuestion(payload, id),
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ['get_predefined_question'] });
      console.log(data);
    },
    onError: (error) => {
      toast.error('Adding Question Failed', { description: error.message });
    },
  });
};
